<div class="container">
  <div class="d-flex align-items-center pt-30 pb-20">
    <!-- Title -->
    <h5 class="m-0 font-size-18 wallet-redeemed-title">{{ 'wallet.redeemed.title' | translate }}</h5>
  </div>
  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <fgbcl-rewards-wallet-redeemed-list
        [redeemedItems]="walletItems.walletItemsClaimed"
        [style]="'list'"
      ></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="border rounded">
    <div class="font-size-12 text-center py-3">
      {{ 'claimed.rewards.placeholder.description' | translate }}
    </div>
  </div>
</ng-template>
